import http from 'conversations-http/clients/http';
export const getSensistiveDataSettings = () => http.get('data-privacy-settings/hub-settings');